var _circle, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#7C90B1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F2F2F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.8575 30.6602C27.5942 30.1292 25.6842 28.7581 24.6498 28.4465C23.6652 28.1492 22.69 27.8117 21.8763 27.4294C21.8834 27.4223 21.8881 27.42 21.8881 27.42L21.7624 27.2335C21.8027 27.1958 21.8122 27.1698 21.7814 27.1627C21.4777 27.0872 20.9794 24.2907 20.9794 24.2907C20.977 24.3072 20.9747 24.3261 20.9747 24.3426V24.2907C20.4741 24.1751 20.0043 24.0712 19.5203 23.9839C19.3732 23.0187 19.2569 21.9614 19.2854 21.506C19.7836 20.9231 20.2297 20.3024 20.3839 19.8115C20.7493 18.641 20.8774 17.9708 20.8774 17.9708C20.8774 17.9708 21.2072 17.9708 21.4278 17.6994C21.6485 17.428 21.7031 15.6958 21.8668 15.2073C22.0328 14.7188 22.142 13.907 21.5915 13.9612C21.4872 13.9707 21.3946 14.0132 21.3092 14.0722C21.3638 13.7111 21.9688 12.8001 21.9688 12.8001C21.9688 12.8001 22.4765 9.7393 22.3745 9.53398C22.2725 9.33103 22.8822 9.0738 21.9688 7.39116C21.0601 5.71088 16.9959 3.26126 15.3184 3.05831C13.641 2.85535 11.3064 3.05831 10.3408 5.71088C10.3408 5.71088 7.79973 6.27255 7.44622 8.92512C7.09033 11.5777 9.07143 13.4656 9.07143 14.2822C9.07143 14.2845 9.07143 14.2893 9.07143 14.2916C8.9623 14.0084 8.84367 13.7819 8.73216 13.7465C8.40237 13.6379 7.79736 13.6379 7.9065 14.9382C8.01564 16.2386 8.15087 15.2309 8.62064 17.6475C8.89586 19.0563 9.38936 17.9731 9.38936 17.9731C9.38936 17.9731 9.84964 20.2151 10.9505 21.8222C10.9529 22.3815 10.9624 23.2688 10.9885 23.9839C10.5211 24.0712 10.0513 24.1751 9.58154 24.2954V24.3544C9.58154 24.3426 9.57679 24.3332 9.57442 24.3214C9.57442 24.3214 9.09516 27.1226 8.7891 27.2005C8.74639 27.2123 8.78198 27.2548 8.87451 27.3232L8.521 27.5899C8.36203 27.7102 8.19121 27.8117 8.01089 27.8967L7.07372 28.3356L6.30738 28.5339C5.65492 28.7014 5.0594 29.0342 4.57302 29.4967L3 31H27.9999C27.9999 31 28.0094 30.9646 27.8575 30.6602Z",
    fill: "#F2F2F2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.283d292b.svg";
export { ForwardRef as ReactComponent };